module.exports = __webpack_public_path__ + "book1.9096a406.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/book1.jpg
// module id = 6FYu
// module chunks = 0